// import react,{useEffect,useState} from 'react';
import Papa from 'papaparse';
import { calculateMasteryLevel, calculateLevelStats } from './calculations';
import { useSelector } from 'react-redux';
// Assessed grades: Grade 4 and Grade 6 are assessed.
export let ASSESSED_GRADES ;

function parseRaw(text) {
  const result = Papa.parse(text, { header: false, skipEmptyLines: true });
  return result.data;
}

export function processAllData(rawData,items,SchoolData) {
   ASSESSED_GRADES = JSON.parse(localStorage.getItem("AGrades"));
  const masterList = new Map();
  const schoolInfo = new Map();
  const mathResults = new Map();
  const englishResults = new Map();
  const loMap = new Map();
  const levelMap = new Map();
  const parseLevel = (raw) => {
    if (!raw) return NaN; 
    const s = raw.trim().toLowerCase();
    if (s === 'pre-primary') return 0;
    const m = s.match(/(\d+)/);
    return m ? parseInt(m[1]) : NaN;
  };

  // 1. Process English and Math Response Tabs First
  const processResponseCSV = (csvText, subject, resultMap) => {
    const rows = parseRaw(csvText);
    if (rows.length < 6) return;

    const header = rows[1].map(h => (h || '').trim());
    const levelRow = rows[3];
    const loRow = rows[4];
    const idx = {
      schoolId: header.indexOf('SchoolId'),
      schoolName: header.indexOf('SchoolName'),
      district: header.indexOf('District'),
      grade: header.indexOf('Grade'),
      section: header.indexOf('Section'),
      loginId: header.indexOf('LoginId'),
      firstName: header.indexOf('FirstName'),
      lastName: header.indexOf('LastName')
    };
    const qCols = [];
    for (let c = 0; c < header.length; c++) {
      if (/^Q\d+$/.test(header[c])) {
        qCols.push(c);
      }
    }

    const levels = qCols.map(c => parseLevel(levelRow[c]));
    const los = qCols.map(c => (loRow[c] || '').trim());

    for (let r = 5; r < rows.length; r++) {
      const row = rows[r];
      if (!row || row.length === 0) continue;
      const loginId = (row[idx.loginId] || '').trim();
      if (!loginId) continue;

      const regGrade = parseInt(row[idx.grade]);
      const schoolId = (row[idx.schoolId] || '').trim();
      const schoolName = (row[idx.schoolName] || '').trim();
      const district = (row[idx.district] || '').trim();

      // Backfill school lookup details
      if (schoolId && schoolName) {
        schoolInfo.set(schoolId, { name: schoolName, district: district || 'Unknown' });
      }

      if (!isNaN(regGrade) && !ASSESSED_GRADES.includes(regGrade)) continue;
if (schoolName !== (items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue)) {
  continue;
}
      // Ensure student exists in master list
      if (!masterList.has(loginId)) {
        masterList.set(loginId, {
          id: loginId,
          name: `${row[idx.firstName] || ''} ${row[idx.lastName] || ''}`.trim() || 'Unknown',
          grade: isNaN(regGrade) ? 0 : regGrade,
          section: (row[idx.section] || '').trim(),
          schoolId: schoolId,
          district: district || 'Unknown',
          school: schoolName || 'Unknown',
          status: 'Absent'
        });
      }

      const answers = qCols.map(c => {
        const raw = row[c];
        return (raw === '' || raw === undefined || raw === null) ? NaN : parseInt(raw ==="U" ? 0 : raw);
      });
// console.log(answers, "----",levels)
      const masteryLevel = calculateMasteryLevel(answers, levels);

      resultMap.set(loginId, {
        answers,
        levels,
        masteryLevel,
        stats: calculateLevelStats(answers, levels)
      });

      masterList.get(loginId).status = 'Participated';

      // Build global maps
      const studentGrade = isNaN(regGrade) ? null : regGrade;
      if (studentGrade) {
        qCols.forEach((c, qi) => {
          if (los[qi]) {
            loMap.set(`${subject}-${studentGrade}-${qi + 1}`, los[qi]);
          }
          if (!isNaN(levels[qi])) {
            levelMap.set(`${subject}-${studentGrade}-${qi + 1}`, levels[qi]);
          }
        });
      }
    }
  };

  // Process response tabs
  // if (rawData.response_grade6_math) processResponseCSV(rawData.response_grade6_math, 'Math', mathResults);
  // if (rawData.response_grade6_english) processResponseCSV(rawData.response_grade6_english, 'English', englishResults);
  // if (rawData.response_grade5_math) processResponseCSV(rawData.response_grade5_math, 'Math', mathResults);
  // if (rawData.response_grade5_english) processResponseCSV(rawData.response_grade5_english, 'English', englishResults);
  {
    ASSESSED_GRADES.map((Grade) => {
      if (rawData[`response_grade${Grade}_math`]) processResponseCSV(rawData[`response_grade${Grade}_math`], 'Math', mathResults);
      if (rawData[`response_grade${Grade}_english`]) processResponseCSV(rawData[`response_grade${Grade}_english`], 'English', englishResults);
    }
    )
  }
  // 2. Process Master/Registration CSV Files (overwrites section with official roster value)
  const processMasterCSV = (csvText, schoolKey) => {
    const rows = parseRaw(csvText);
    if (rows.length < 4) return;
    const header = rows[2].map(h => (h || '').trim().toLowerCase());

    const idx = {
      studentId: header.indexOf('studentid'),
      name: header.indexOf('student name'),
      grade: header.indexOf('grade'),
      section: header.indexOf('section')
    };
    for (let r = 3; r < rows.length; r++) {
      const row = rows[r];
      if (!row || row.length === 0) continue;
      const studentId = (row[idx.studentId] || '').trim();
      const regGrade = parseInt(row[idx.grade]);
      if (!studentId || isNaN(regGrade)) continue;
      if (!ASSESSED_GRADES.includes(regGrade)) continue;

      const schoolId = studentId.substring(0, 6);
      const rosterSection = (row[idx.section] || '').trim();
      if (!masterList.has(studentId) && regGrade > 0) {
        masterList.set(studentId, {
          id: studentId,
          name: (row[idx.name] || '').trim() || 'Unknown',
          grade: regGrade,
          section: rosterSection,
          schoolId: schoolId,
          schoolKey: schoolKey,
          district: 'Unknown',
          school: 'Unknown',
          status: 'Absent'
        });
      } else {
        masterList.get(studentId).section = rosterSection;
        masterList.get(studentId).grade = regGrade;
      }

    }
  };
  // Process master files
  // if (rawData.master_Madhapur) processMasterCSV(rawData.master_Madhapur, 'Madhapur');
  // if (rawData['master_Vasant Nagar']) processMasterCSV(rawData['master_Vasant Nagar'], 'Vasant Nagar');
  // if (rawData.master_Kokapet) processMasterCSV(rawData.master_Kokapet, 'Kokapet');
  // {JSON.parse(localStorage.getItem("ASchools")).map((SH)=>
  // {
  //   if (rawData[`master_${SH}`]) processMasterCSV(rawData[`master_${SH}`], SH);
  // }
  // )}
  if (rawData[`master_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}`]) processMasterCSV(rawData[`master_${items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue}`], items?.userTypeId === 2 ? items?.schoolName?.trim() : SchoolData?.levelValue);

  // Backfill school name/district on master list
  masterList.forEach(student => {
    const info = schoolInfo.get(student.schoolId);
    if (info) {
      student.school = info.name;
      student.district = info.district;
    }
    // else if (student.schoolKey) {
    //   student.school = `Global Edge, ${student.schoolKey}`;
    // }
  });

  // 3. Merge Roster and Results
  const allStudentsData = [];
  masterList.forEach((student, studentId) => {
    const mathData = mathResults.get(studentId) || { masteryLevel: 0, stats: {}, answers: [], levels: [] };
    const englishData = englishResults.get(studentId) || { masteryLevel: 0, stats: {}, answers: [], levels: [] };
    const countCorrect = (list) => list.filter(v => v === 1).length;
    const countAttempted = (list) => list.filter(v => !isNaN(v)).length;

    const mathCorrect = countCorrect(mathData.answers);
    const mathAttempted = countAttempted(mathData.answers);
    const englishCorrect = countCorrect(englishData.answers);
    const englishAttempted = countAttempted(englishData.answers);

    const totalAttempted = mathAttempted + englishAttempted;
    const scorePercentage = totalAttempted > 0 ? ((mathCorrect + englishCorrect) / totalAttempted) * 100 : 0;

    let mathMastery = mathData.masteryLevel;
    let englishMastery = englishData.masteryLevel;
    const registeredGrade = student.grade;

    // Custom Logic: Grade 1 students at Level 2 should be shown as Level 1
    if (registeredGrade === 1) {
      if (mathMastery === 2) mathMastery = 1;
      if (englishMastery === 2) englishMastery = 1;
    }

    allStudentsData.push({
      id: student.id,
      name: student.name,
      registeredGrade: registeredGrade,
      section: student.section || '',
      district: student.district,
      school: student.school,
      status: student.status,
      mathMastery,
      englishMastery,
      mathScore: mathAttempted > 0 ? (mathCorrect / mathAttempted) * 100 : 0,
      englishScore: englishAttempted > 0 ? (englishCorrect / englishAttempted) * 100 : 0,
      mathCorrect,
      mathAttempted,
      englishCorrect,
      englishAttempted,
      totalCorrect: mathCorrect + englishCorrect,
      totalAttempted,
      mathStats: mathData.stats,
      englishStats: englishData.stats,
      scorePercentage,
      participated: student.status === 'Participated'
    });
  });

  return {
    allStudentsData,
    schoolInfo,
    loMap,
    levelMap,
    mathResults,
    englishResults,
    masterList
  };
}
